import React from "react"
import ReactDOM from 'react-dom';
import { PrimaryButton } from '../PrimaryButton/PrimaryButton';
import {
  DialogOverlay,
  DialogContainer,
  TextContainer,
  DialogTitle,
  DialogDescription,
  ButtonContainer
} from './DialogConfirmationBox.styles'

export type DialogConfirmationBoxProps = {
  title: string
  description: string
  positiveButtonText: string
  negativeButtonText: string
  onPositiveClick: () => Promise<void>
  onNegativeClick: () => Promise<void>
  onOverlayClick?: () => Promise<void>
  isOpen: boolean
}

const DialogConfirmationBox: React.FC<DialogConfirmationBoxProps> = ({
  title,
  description,
  positiveButtonText,
  negativeButtonText,
  onPositiveClick,
  onNegativeClick,
  onOverlayClick,
  isOpen
}) => {
  if (!isOpen) return null

  return ReactDOM.createPortal(
    <DialogOverlay onClick={onOverlayClick}>
      <DialogContainer onClick={(e) => e.stopPropagation()}>
        <TextContainer>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </TextContainer>
        <ButtonContainer>
          <PrimaryButton
            variant="primary"
            onClick={onPositiveClick}
          >
            {positiveButtonText}
          </PrimaryButton>
          <PrimaryButton
            variant="danger"
            onClick={onNegativeClick}
          >
            {negativeButtonText}
          </PrimaryButton>
        </ButtonContainer>
      </DialogContainer>
    </DialogOverlay>,
    document.body
  )
}

export default DialogConfirmationBox
